/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Field_GradeInputs */

const vi_order_lot_trace_field_grade = /** @type {(inputs: Order_Lot_Trace_Field_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạng`)
};

/**

* @param {Order_Lot_Trace_Field_GradeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_field_grade = /** @type {((inputs?: Order_Lot_Trace_Field_GradeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Field_GradeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_field_grade(inputs)
});